import { render, staticRenderFns } from "./dangrchengjiao.vue?vue&type=template&id=8420c8ba&scoped=true"
import script from "./dangrchengjiao.vue?vue&type=script&lang=js"
export * from "./dangrchengjiao.vue?vue&type=script&lang=js"
import style0 from "./dangrchengjiao.vue?vue&type=style&index=0&id=8420c8ba&prod&lang=scss&scoped=true"
import style1 from "./dangrchengjiao.vue?vue&type=style&index=1&id=8420c8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8420c8ba",
  null
  
)

export default component.exports